import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({ className, dimension = 44 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={dimension}
    height={dimension}
    viewBox="0 0 44 44"
    fill="none"
  >
    <mask
      id="mask0_15662_23131"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="44"
      height="44"
    >
      <rect width="44" height="44" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_15662_23131)">
      <path
        d="M19.4346 30.4337L32.3596 17.5087L29.793 14.942L19.4346 25.3003L14.2096 20.0753L11.643 22.642L19.4346 30.4337ZM22.0013 40.3337C19.4652 40.3337 17.0819 39.8524 14.8513 38.8899C12.6207 37.9274 10.6805 36.6212 9.03047 34.9712C7.38047 33.3212 6.07422 31.3809 5.11172 29.1503C4.14922 26.9198 3.66797 24.5364 3.66797 22.0003C3.66797 19.4642 4.14922 17.0809 5.11172 14.8503C6.07422 12.6198 7.38047 10.6795 9.03047 9.02949C10.6805 7.37949 12.6207 6.07324 14.8513 5.11074C17.0819 4.14824 19.4652 3.66699 22.0013 3.66699C24.5374 3.66699 26.9207 4.14824 29.1513 5.11074C31.3819 6.07324 33.3221 7.37949 34.9721 9.02949C36.6221 10.6795 37.9284 12.6198 38.8909 14.8503C39.8534 17.0809 40.3346 19.4642 40.3346 22.0003C40.3346 24.5364 39.8534 26.9198 38.8909 29.1503C37.9284 31.3809 36.6221 33.3212 34.9721 34.9712C33.3221 36.6212 31.3819 37.9274 29.1513 38.8899C26.9207 39.8524 24.5374 40.3337 22.0013 40.3337ZM22.0013 36.667C26.0957 36.667 29.5638 35.2462 32.4055 32.4045C35.2471 29.5628 36.668 26.0948 36.668 22.0003C36.668 17.9059 35.2471 14.4378 32.4055 11.5962C29.5638 8.75449 26.0957 7.33366 22.0013 7.33366C17.9069 7.33366 14.4388 8.75449 11.5971 11.5962C8.75547 14.4378 7.33464 17.9059 7.33464 22.0003C7.33464 26.0948 8.75547 29.5628 11.5971 32.4045C14.4388 35.2462 17.9069 36.667 22.0013 36.667Z"
        fill="#67AC1E"
      />
    </g>
  </svg>
);

export default Icon;
